import { Routes } from '@angular/router';
import { PermissionsEnum } from '../permission.enum';
import { permissionGuard } from '../shared/core/guard/permission.guard';
import { loanDetailsRoutes } from './components/loans/components/loan-details/loan-details.routes';

export const collectRoutes: Routes = [
  {
    path: 'loans',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('./components/loans/loans.component').then((m) => m.LoansComponent),
  },
  {
    path: 'loans/:uuid',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('./components/loans/components/loan-details/loan-details.component').then((m) => m.LoanDetailsComponent),
    children: loanDetailsRoutes,
  },
  {
    path: 'customers',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('./components/customers/customers.component').then((m) => m.CustomersComponent),
  },
  {
    path: 'customers/:uuid',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('./components/customers/components/customer-details/customer-details.component').then((m) => m.CustomerDetailsComponent),
  },
  {
    path: 'transactions',
    canActivate: [permissionGuard(PermissionsEnum.TransactionView)],
    loadComponent: () => import('./components/transactions/transactions.component').then((m) => m.TransactionsComponent),
  },
  {
    path: 'proof-of-payment',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () => import('./components/proof-of-payment/proof-of-payment.component').then((m) => m.ProofOfPaymentComponent),
  },
  {
    path: 'proof-of-payment/:uuid',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () =>
      import('./components/proof-of-payment/components/proof-of-payment-details/proof-of-payment-details.component').then((m) => m.ProofOfPaymentDetailsComponent),
  },
  {
    path: 'due-payments',
    canActivate: [permissionGuard(PermissionsEnum.LoanView)],
    loadComponent: () =>
      import('./components/due-payments/due-payments.component').then((m) => m.DuePaymentsComponent),
  },
  {
    path: '',
    redirectTo: 'loans',
    pathMatch: 'full',
  },
];
